export * from './IndustryCardsCarousel';
export { default } from './IndustryCardsCarousel';
export type * from './types';